import { ExportFileType } from "src/api/exportTypes";

export const SERVICE_EXPORT_FILE_TYPES = [ExportFileType.XLSX];